module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAABCAMAAAAsPuSGAAAABlBMVEX///8AAABVwtN+AAAADElEQVQI12NgZGQAAAAJAAOx5/+cAAAAAElFTkSuQmCC"